module.exports = __webpack_public_path__ + "static/media/teamwork.3f2bdd0b.png";